import featuredCarousel from '../components/featured-carousel';
import advertisingCarousel from '../components/advertising-carousel';
import offerCarousel from '../components/offer-carousel';
import postCarousel from '../components/post-carousel';
import floater from '../components/floater';

export default {
  init() {
    featuredCarousel.fire();
    advertisingCarousel.fire();
    offerCarousel.fire();
    postCarousel.fire();
    floater.fire();
  },

  finalize() {
  },
};

$(document).on('click', '.limited2', function(){
   var limit = 4;
   var counter = $('.limited2:checked').length;
   if(counter > limit) {
      this.checked = false;
   }
});

$(document).on('click', '.limited', function(){
   var limit = 4;
   var counter = $('.limited:checked').length;
   if(counter > limit) {
      this.checked = false;
   }
});

$(document).on('click', '.3limited', function(){
   var limit = 3;
   var counter = $('.3limited:checked').length;
   if(counter > limit) {
      return false;
   }
});

function condicional(){
  $(document).ready(function(){
    
    // function limitValidation(maxLimit) {
    //   if (limitedCounter == undefined) 
    //     var limitedCounter = 1;
    //   else 
    //     limitedCounter += 1;

    //   if(limitedCounter > maxLimit) return false;
    // }

    // $('.3limited').click(function(){
    //   if ($(this).checked)
    //     limitValidation(3)
    // });

    if($("#id_ultimo").val() != ""){
       $(".ultimo").attr("required", true);
     }else $(".ultimo").attr("required", false);
     if($("#id_penultimo").val() != ""){
        $(".penultimo").attr("required", true);
      }else $(".penultimo").attr("required", false);
      if($("#id_antepenultimo").val() != ""){
         $(".antepenultimo").attr("required", true);
       }else $(".antepenultimo").attr("required", false);
  });
}
condicional();



// WEBPACK FOOTER //
// ./scripts/routes/home.js